import React from "react";
import { useContent } from "../context/ContentContext";

export default function Subsidiaries() {
  const { content } = useContent();
  const sub = content?.subsidiaries;
  if (!sub) return null;
  const items = sub.items ?? [];
  if (items.length === 0) return null;

  const handleClick = (item) => (e) => {
    if (!item.link) return;
    if (item.external) {
      window.open(item.link, "_blank", "noopener,noreferrer");
    } else if (item.link.startsWith("/")) {
      window.location.href = item.link;
    } else if (item.link.startsWith("#")) {
      e.preventDefault();
      const id = item.link.slice(1);
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section
      id="subsidiaries"
      className="relative py-14 md:py-20 bg-[#F9F8F6] border-t border-[#E2E0D8]"
      data-testid="subsidiaries-section"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        {sub.overline && (
          <div className="text-[#4A4F6B] uppercase text-xs tracking-[0.3em] font-semibold mb-10 md:mb-14 text-center">
            {sub.overline}
          </div>
        )}
        <div
          className="grid grid-cols-2 gap-10 md:gap-16 items-center"
          style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}
        >
          {items.map((s, i) => (
            <div
              key={s.id}
              className={`flex items-center justify-center ${s.link ? "cursor-pointer" : ""}`}
              onClick={handleClick(s)}
              data-testid={`subsidiary-${i + 1}`}
            >
              <img
                src={s.logo_url}
                alt={s.name}
                className={`max-h-10 md:max-h-12 w-auto object-contain opacity-90 transition-all duration-200 ${s.link ? "hover:opacity-100 hover:scale-105" : ""}`}
                draggable={false}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
